import Vue from 'vue'
import Vuex from 'vuex'
import authModule from './modules/auth';
import toasterModule from './modules/toasterModule';
import quotaLine from "@/store/modules/quotaLine";
import historyModule from "@/store/modules/historyModule";
import confirmBeforeLeaving from "@/store/modules/confirmBeforeLeaving";
import {globalInformationsModule} from "@/store/modules/globalInformationsModule";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    authModule,
    toasterModule,
    quotaLine,
    historyModule,
    confirmBeforeLeaving,
    globalInformationsModule,
  },
});
